import { api } from "../api";

export type TransferStatus = "PENDING" | "IN_TRANSIT" | "COMPLETED" | "CANCELLED";

export interface ItemTransfer {
  id: string;
  tenantId: string;
  itemId: string;
  fromBranchId: string;
  toBranchId: string;
  status: TransferStatus;
  requestedById: string;
  approvedById?: string | null;
  notes?: string | null;
  requestedAt: string;
  dispatchedAt?: string | null;
  completedAt?: string | null;
  updatedAt: string;
  item?: {
    id: string;
    barcode: string;
    accessionNumber: number;
    statusCode: string;
    branchId?: string | null;
    biblio?: { title: string; authors?: string[] | null };
    branch?: { id: string; name: string; code: string } | null;
  };
  fromBranch?: { id: string; name: string; code: string };
  toBranch?: { id: string; name: string; code: string };
}

export interface CreateTransferDto {
  itemId?: string;
  itemBarcode?: string;
  fromBranchId?: string;
  toBranchId: string;
  notes?: string;
}

export interface TransferListParams {
  branchId?: string;
  status?: TransferStatus;
  direction?: "inbound" | "outbound";
}

export const itemTransfersApi = {
  create: async (data: CreateTransferDto): Promise<ItemTransfer> => {
    const res = await api.post("/item-transfers", data);
    return res.data;
  },

  getAll: async (params?: TransferListParams): Promise<ItemTransfer[]> => {
    const res = await api.get("/item-transfers", { params });
    return res.data;
  },

  getById: async (id: string): Promise<ItemTransfer> => {
    const res = await api.get(`/item-transfers/${id}`);
    return res.data;
  },

  approve: async (id: string, notes?: string): Promise<ItemTransfer> => {
    const res = await api.patch(`/item-transfers/${id}/approve`, { notes });
    return res.data;
  },

  complete: async (id: string, notes?: string): Promise<ItemTransfer> => {
    const res = await api.patch(`/item-transfers/${id}/complete`, { notes });
    return res.data;
  },

  cancel: async (id: string, notes?: string): Promise<ItemTransfer> => {
    const res = await api.patch(`/item-transfers/${id}/cancel`, { notes });
    return res.data;
  },

  createBulk: async (
    transfers: CreateTransferDto[]
  ): Promise<{
    succeeded: number;
    failed: number;
    results: { success: boolean; itemId: string; transferId?: string; error?: string }[];
  }> => {
    const res = await api.post("/item-transfers/bulk", { transfers });
    return res.data;
  },
};
